module.exports = __webpack_public_path__ + "static/media/bg-products.cfd2400b.png";